import { ModulesConfig } from '@eui/core';

export const MODULES: ModulesConfig = {
  core: {
    base: '/api',
  },
};
